import React from 'react';
import { MetaPixel } from './components/MetaPixel';
import { Header } from './components/Header';
import { HeroSection } from './components/HeroSection';
import { PainPointsSection } from './components/PainPointsSection';
import { BenefitsSection } from './components/BenefitsSection';
import { QueIncluye } from './components/QueIncluye';
import { BonusSection } from './components/BonusSection';
import { UrgencySection } from './components/UrgencySection';
import { PricingSection } from './components/PricingSection';
import { ActividadesPreview } from './components/ActividadesPreview';
import { TestimoniosSection } from './components/TestimoniosSection';
import { FAQSection } from './components/FAQSection';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { SocialProofPopup } from './components/SocialProofPopup';
export function App() {
  return <div className="bg-[#0a1628] min-h-screen font-sans text-gray-100 selection:bg-[#22c55e] selection:text-white" data-id="element-0">
      <MetaPixel data-id="element-1" />
      <Header data-id="element-2" />

      <main data-id="element-3">
        <HeroSection data-id="element-4" />
        <PainPointsSection data-id="element-5" />
        <BenefitsSection data-id="element-6" />
        <QueIncluye data-id="element-7" />
        <BonusSection data-id="element-8" />
        <UrgencySection data-id="element-9" />
        <PricingSection data-id="element-10" />
        <ActividadesPreview data-id="element-11" />
        <TestimoniosSection data-id="element-12" />
        <FAQSection data-id="element-13" />
        <PricingSection compact data-id="element-14" />
        <FinalCTA data-id="element-15" />
      </main>

      <Footer data-id="element-16" />
      <SocialProofPopup data-id="element-17" />
    </div>;
}